import { render, staticRenderFns } from "./OTPAuth.vue?vue&type=template&id=700bd4c2&"
import script from "./OTPAuth.vue?vue&type=script&lang=js&"
export * from "./OTPAuth.vue?vue&type=script&lang=js&"
import style0 from "./OTPAuth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports